import { Icon } from "@/components/Icon/Icon";
import { SubstanceGroupBy } from "./SubstanceGroupBy";
import type { GroupKey } from "./grouping";

interface SubstanceToolbarProps {
  search: string;
  onSearch: (s: string) => void;
  groupBy: GroupKey;
  onGroupBy: (g: GroupKey) => void;
  shown: number;
  total: number;
  allExpanded: boolean;
  onToggleAll: () => void;
  showExpandAll: boolean;
}

export function SubstanceToolbar({
  search, onSearch, groupBy, onGroupBy, shown, total,
  allExpanded, onToggleAll, showExpandAll,
}: SubstanceToolbarProps) {
  return (
    <div className="hstack" style={{
      padding: "10px 16px", borderBottom: "1px solid var(--line)",
      background: "var(--panel)", gap: 12,
    }}>
      <div style={{ position: "relative", flex: 1, maxWidth: 360, minWidth: 160 }}>
        <div style={{ position: "absolute", left: 11, top: 8, color: "var(--ink-4)" }}>
          <Icon name="search" size={13} />
        </div>
        <input
          className="input"
          placeholder="Search name, code, CAS, supplier, lot…"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          style={{ paddingLeft: 33, fontSize: 12, padding: "7px 10px 7px 33px" }}
        />
      </div>
      <SubstanceGroupBy value={groupBy} onChange={onGroupBy} />
      <span className="mono" style={{ fontSize: 10.5, color: "var(--ink-4)", whiteSpace: "nowrap" }}>
        {shown} of {total}
      </span>
      <div style={{ flex: 1 }} />
      {showExpandAll && groupBy !== "none" && (
        <button type="button" className="btn xs ghost" onClick={onToggleAll}>
          <span style={{ display: "inline-flex", transform: allExpanded ? "rotate(90deg)" : "none", transition: "transform 120ms" }}>
            <Icon name="chevron-r" size={10} />
          </span>
          {allExpanded ? "Collapse all" : "Expand all"}
        </button>
      )}
      <button type="button" className="btn xs ghost"><Icon name="download" size={10} />Export</button>
      <button type="button" className="btn xs ghost"><Icon name="filter" size={10} />Columns</button>
    </div>
  );
}
